export default "/images/513d5c0168398ae0bff45af7c1c082c1.avif";